var _path, _g, _path2, _circle, _path3, _g2, _g3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStyleGuidesCreate = function SvgStyleGuidesCreate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 185 181"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#style_guides_create_svg__a)",
    d: "M102.04 22.625H56.79c-8.33 0-15.083 6.753-15.083 15.083v105.584c0 8.33 6.753 15.083 15.083 15.083h75.417c8.33 0 15.083-6.753 15.083-15.083V67.875l-45.25-45.25Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#style_guides_create_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#style_guides_create_svg__c)",
    d: "M102.043 67.875v-45.25l45.25 45.25h-45.25Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.332 98.042a7.542 7.542 0 0 1 7.542-7.542h45.25a7.541 7.541 0 0 1 7.541 7.542 7.54 7.54 0 0 1-7.541 7.541h-45.25a7.541 7.541 0 0 1-7.542-7.541ZM64.332 128.208a7.541 7.541 0 0 1 7.542-7.541h45.25a7.542 7.542 0 0 1 0 15.083h-45.25a7.542 7.542 0 0 1-7.542-7.542Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 60.5,
    r: 15.5,
    fill: "#FFB800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M34.855 53.855a.83.83 0 0 0-.83.83v9.965a3.321 3.321 0 0 0 3.32 3.321h8.304c1.268 0 2.14-.546 2.667-1.28.497-.69.655-1.493.655-2.041a.83.83 0 0 0-.83-.83h-2.492v-9.134a.83.83 0 0 0-.83-.83h-9.964Zm9.134 9.964v-8.303h-8.304v9.134a1.66 1.66 0 0 0 1.652 1.66h.009c.282 0 .724-.091 1.072-.341.305-.22.589-.593.589-1.32a.83.83 0 0 1 .83-.83h4.152Zm1.66 2.492h-5.373c.133-.247.238-.524.305-.83h6.53a1.64 1.64 0 0 1-.142.24c-.22.306-.594.59-1.32.59Zm-8.303-8.304a.83.83 0 0 1 .83-.83h3.321a.83.83 0 0 1 0 1.66h-3.321a.83.83 0 0 1-.83-.83Zm.83 1.66a.83.83 0 0 0 0 1.661h3.321a.83.83 0 1 0 0-1.66h-3.321Z",
    clipRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#style_guides_create_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 60.5,
    r: 15.5,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M36.159 52.362c-.5 0-.904.405-.904.905v14.466c0 .5.405.904.904.904h10.85c.5 0 .904-.404.904-.904v-10.85c0-.24-.095-.47-.265-.64l-3.616-3.616a.904.904 0 0 0-.64-.265H36.16Zm.904 14.467V54.171h5.955l3.087 3.087v9.571h-9.042Zm1.808-6.329a.904.904 0 0 0 0 1.808h5.425a.904.904 0 1 0 0-1.808h-5.425Zm-.904-1.808c0-.5.405-.904.904-.904h3.617a.904.904 0 1 1 0 1.808H38.87a.904.904 0 0 1-.904-.904Zm.904 4.52a.904.904 0 0 0 0 1.809h5.425a.904.904 0 1 0 0-1.809h-5.425Z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#style_guides_create_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#style_guides_create_svg__f)",
    d: "M145 146c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M141.895 117.553a1.001 1.001 0 0 0-1.789 0l-2.991 5.982-.019.037-.99 1.981a1 1 0 1 0 1.789.894l.723-1.447h4.764l.714 1.428a.995.995 0 0 0 .926.572h.905a7.022 7.022 0 0 0 1.548 4.265c-.706.394-1.556.66-2.553.738a1 1 0 1 0 .157 1.994c1.561-.123 2.872-.607 3.921-1.322 1.049.715 2.36 1.199 3.922 1.322a1 1 0 1 0 .156-1.994c-.997-.078-1.847-.344-2.552-.738a7.02 7.02 0 0 0 1.547-4.265H153a1 1 0 0 0 0-2h-3v-1a1 1 0 0 0-2 0v1h-2.382l-.714-1.428-.018-.037-2.991-5.982Zm8.178 9.447h-2.146a4.992 4.992 0 0 0 1.073 2.97 4.986 4.986 0 0 0 1.073-2.97Zm-7.691-4L141 120.236 139.618 123h2.764ZM141 127a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Zm7-6a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1h-2a1 1 0 0 0 0 2h1v1Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "style_guides_create_svg__a",
    x1: 94.499,
    x2: 94.499,
    y1: 22.625,
    y2: 158.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CB4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5689C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "style_guides_create_svg__c",
    x1: 125,
    x2: 102,
    y1: 41.5,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5183BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C95D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "style_guides_create_svg__f",
    x1: 145,
    x2: 145,
    y1: 106,
    y2: 146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DD1B3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "style_guides_create_svg__b",
    width: 53.25,
    height: 53.25,
    x: 96.043,
    y: 22.625,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.321569 0 0 0 0 0.517647 0 0 0 0 0.741176 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3683_15527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3683_15527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "style_guides_create_svg__d",
    width: 82.667,
    height: 82.667,
    x: 0.167,
    y: 26.917,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.917
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3683_15527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3683_15527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "style_guides_create_svg__e",
    width: 50.074,
    height: 50.074,
    x: 122.481,
    y: 103.481,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.519,
    dy: 2.519
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.519
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3683_15527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3683_15527",
    result: "shape"
  })))));
};
export default SvgStyleGuidesCreate;